import { render, staticRenderFns } from "./CustomerFormView.vue?vue&type=template&id=4b089c30&scoped=true&"
import script from "./CustomerFormView.vue?vue&type=script&lang=js&"
export * from "./CustomerFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b089c30",
  null
  
)

export default component.exports